module.exports = __webpack_public_path__ + "assets/img/ic-internet-bank.c668970a.svg";